export const CampaignString = {
    title: 'Campagne',
    addCampaign: 'Aggiungi Campagna',
    name:'Nome',
    product: 'Prodotto',
    opening_date: 'Data Apertura',
    closing_date: 'Data Chiusura',
    action: 'Azioni',
    status_active : 'Attivo',
    status_suspended : 'Sospeso',
    status_disabled : 'Disabilitato',
    status_expired : 'Scaduto',
    editCampaign: 'Modifica Campagna',
    viewCampaign: 'Visualizza Campaign',
    
    

}